import moment from 'moment';

type Address = {
  street: string;
  shortNameStreet: string;
  addressNumber: string;
  postalCode: string;
  municipality: string;
  state: string;
};
export const VALIDATE_APPLICATION_POLICY = (
  address: Address,
  buildingUnit: string,
  email: string,
  firstName: string,
  lastName: string,
  leaseStart: string,
  leaseEnd: string,
) => `mutation {
  validateApplicationPolicy(
    input:{
      address :{
        street: "${address.street}",
        shortNameStreet: "${address.shortNameStreet}",
        addressNumber: "${address.addressNumber}",
        postalCode: "${address.postalCode}",
        municipality: "${address.municipality}",
        region: ${address.state}
      }
      buildingUnit: "${buildingUnit}",
      email: "${email}",
      firstName: "${firstName}",
      lastName: "${lastName}",
      leaseStart:"${moment(leaseStart).format('YYYY-MM-DD')}",
      leaseEnd:"${moment(leaseEnd).format('YYYY-MM-DD')}"
    }
  ) {
        ... on ApplicationWithValidationOutput {
            application {
                id
                status
            }
            linkId
            validation {
              errors {
                type
                message
              }
            }
          }
        ... on ErrorListOutput {
            errors: errors {
                type
                message
            }
          }
    }
}`;
